"use client";

import dynamic from "next/dynamic";
import {
  BicepsFlexed,
  CalendarRange,
  Coffee,
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
  MessageCircleQuestion,
  Mountain,
  Phone,
  SquareParking,
} from "lucide-react";
import type { LucideProps } from "lucide-react";
import type { IconName } from "lucide-react/dynamic";
import type { ComponentType } from "react";

// Storyblok's icon fields (button, icon_block) are free text: a Lucide name
// such as "Phone". `import * as LucideIcons` put all 1585 Lucide icons into the
// JavaScript every visitor loads (lib/storyblok.ts brings every component into
// the browser). These are the ones the content uses (2026-10). Any other name
// still works: it loads Lucide's import map and then that one icon.
const bundled: Record<string, ComponentType<LucideProps>> = {
  BicepsFlexed,
  CalendarRange,
  Coffee,
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
  MessageCircleQuestion,
  Mountain,
  Phone,
  SquareParking,
};

const DynamicIcon = dynamic(() => import("lucide-react/dynamic").then((m) => m.DynamicIcon), { ssr: false });

// "MessageCircleQuestion" → "message-circle-question", "Grid2x2" → "grid-2x2"
const kebab = (name: string) =>
  name
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([a-zA-Z])(\d)/g, "$1-$2")
    .toLowerCase();

export default function LucideIcon({ name, ...props }: Omit<LucideProps, "name"> & { name: string }) {
  const Icon = bundled[name];
  if (Icon) return <Icon {...props} />;
  return <DynamicIcon {...props} name={kebab(name) as IconName} />;
}
